import React, { useState, useEffect } from 'react';
import { TextField } from '@mui/material';
import TopNavbar from '../../components/TopNavBar/TopNavBar';
import {
    HeaderText,
    BackgroundContainer,
    SearchBarContainer,
    SearchButton,
    BottomSectionContainer,
    ScaleComputingSection,
    BestSellerSection,
} from './LandingPage.styles';
import BestSellerSlide from '../../components/BestSellerSlider/BestSellerSlide';
import ScaleComputingCarousel from '../../components/ScaleComputingCarousel/ScaleComputingCarousel';
import { useNavigate, useLocation } from 'react-router-dom';

function LandingPage() {
    const [tabIndex, setTabIndex] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const searchParam = params.get('search');
        if (searchParam) setSearchTerm(searchParam);
    }, [location.search]);

    const handleSearch = () => {
        if (!searchTerm.trim()) return;
        navigate(`/landing/products?search=${encodeURIComponent(searchTerm)}`);
    };

    return (
        <>
            <TopNavbar onTabChange={setTabIndex} />
            <BackgroundContainer>
                <div>
                    <HeaderText>
                        Welcome to AfricaPlus Direct International
                    </HeaderText>
                    <SearchBarContainer>
                        <TextField
                            label="Search for internal products..."
                            variant="outlined"
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleSearch()}
                        />
                        <SearchButton
                            variant="contained"
                            onClick={handleSearch}
                            id="search-button"
                        >
                            SEARCH
                        </SearchButton>
                    </SearchBarContainer>
                </div>
            </BackgroundContainer>

            <BottomSectionContainer>
                <BestSellerSection>
                    <BestSellerSlide
                        onProductSelect={(productId, fullProduct) => {
                            if (productId) {
                                navigate(`/landing/products?productId=${productId}`);
                            } else if (fullProduct) {
                                const combinedValue = `${fullProduct.brand ? fullProduct.brand + ' ' : ''}${fullProduct.description || fullProduct.name || ''}`.trim();
                                setSearchTerm(combinedValue);
                                navigate(`/landing/products?search=${encodeURIComponent(combinedValue)}`);
                            }
                        }}
                    />
                </BestSellerSection>

                <ScaleComputingSection>
                    <ScaleComputingCarousel />
                </ScaleComputingSection>
            </BottomSectionContainer>
        </>
    );
}

export default LandingPage;
